<template>

    <fragment>

        <LoginHeader>
            <div class="level-item">
                <router-link :to="{name: 'users_login'}">
                    <img src="../../../images/close.svg" height="40px"/>
                </router-link>
            </div>
        </LoginHeader>

        <router-link :to="{name: 'users_login'}" class="is-hidden-desktop forget-password-close-mobile">
            <img src="../../../images/close.svg" height="40px"/>
        </router-link>
        <div class="sm-container">
            <div class="section">
                <div class="container-fluid">
                    <h1> Forget Password</h1>
                    <div v-if="sent">
                        If the email you specified exists in our system,
                        we've sent a password reset link to it.
                    </div>
                    <fragment v-if="!sent">
                        <h4 class="title is-4"></h4>
                        <div>
                            Enter the email address associated with your account and we’ll send you a link to reset your
                            password.
                        </div>
                        <div class="sep-32"></div>
                        <form action="" id="reset-form" >
                            <div class="columns">
                                <div class="column">
                                    <div class="field">
                                        <label class="label">Email</label>
                                        <div class="control">
                                            <input class="input" vrules="required" type="text"
                                                   placeholder="example@domain.com"
                                                   v-model="email">
                                        </div>
                                        <div class="help is-danger vrule" rule="required">
                                            This field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <button :disabled="loading" @click.prevent="resetPassword()"
                                            :class="{'is-loading': loading, 'is-disabled': loading}"
                                            class="button  btn-block-with-icon  is-fullwidth is-primary">
                                        Send password reset link
                                    </button>
                                </div>
                            </div>
                        </form>
                    </fragment>

                </div>
            </div>
        </div>
    </fragment>


</template>

<script>
    import {LoginAPI} from "../../../apis/LoginAPI";
    import LoginHeader from "../../../shared/components/LoginHeader";
    import {FormValidation} from "../../../shared/directives/formValidation";

    export default {
        props: {},
        components: {LoginHeader},
        data() {
            return {
                email: '',
                sent: false,
                loading: false,
            }
        },
        methods: {
            async resetPassword() {
                this.loading = true;
                let formValidation = new FormValidation('#reset-form')
                if (!formValidation.runAllValidations()) {
                    this.loading = false;
                    return;
                }
                await LoginAPI.resetPassword(this.email);
                this.loading = false;
                this.sent = true;
            },
        },

    };
</script>

<style lang="scss" scoped>
    .forget-password-close-mobile {
        position: absolute;
        top: 10px;
        right: 20px;
    }
</style>
